// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «База знань» (Knowledge Base, ключ `kb`, група `basic`). */
export const knowledgeBaseManifest: IModuleManifest = {
  key: 'kb',
  group: 'basic',
  slug: 'knowledge-base',
  prefix: 'KB',
  name: { en: 'Knowledge Base', uk: 'База знань' },
  entities: [
    { key: 'kb', slug: 'kb', name: { en: 'Knowledge Base', uk: 'База знань' }, main: true },
    { key: 'article_version', slug: 'article-version', name: { en: 'Article Versions', uk: 'Версії' }, main: false },
    { key: 'article_review', slug: 'article-review', name: { en: 'Article Reviews', uk: 'Перевірки' }, main: false },
    { key: 'article_feedback', slug: 'article-feedback', name: { en: 'Article Feedbacks', uk: 'Відгуки' }, main: false },
    { key: 'article_category', slug: 'article-category', name: { en: 'Article Categories', uk: 'Категорії' }, main: false },
    { key: 'article_status', slug: 'article-status', name: { en: 'Article Statuses', uk: 'Статуси' }, main: false },
    { key: 'kb_library', slug: 'kb-library', name: { en: 'Libraries', uk: 'Бібліотеки' }, main: false },
  ],
  loadState: () => import('./state/knowledgeBaseSlice').then((m) => m.knowledgeBaseSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
  loadViews: () => import('./views').then((m) => m.views),
};
